import FileObject from './FileObject'

export default class {
    Id = null;

	Name = "";

	IsActive = false;

	PdfUrl = null;

    ImageUrl = null;
    
    TagId = null;

	Pdf = new FileObject();

    Image = new FileObject();
    
    mapFromDto = function (viewModel) {
		var dto = viewModel;
		if (dto === null)
			return this;

		this.Id = dto.Id;
		this.ImageUrl = dto.ImageUrl;
		this.PdfUrl = dto.PdfUrl;
		this.Name = dto.Name;
        this.IsActive = dto.IsActive;
        this.TagId = dto.TagId;

		return this;
    }
    
    mapToDto = function () {
		var dto = JSON.parse(JSON.stringify(this));

		dto.TagId = dto.TagId == null ? null : dto.TagId.Id;

		if (!this.Pdf.IsUpload()) dto.Pdf = null;
		if (!this.Image.IsUpload()) dto.Image = null;

        return dto;        
    }

    IsOldPdf = () => { return this.PdfUrl !== null; };

	IsOldImage = () => { return this.ImageUrl !== null; };

	IsInValid = () => {
		return  this.Name == "" ||
				(this.ImageUrl == null && !this.Image.IsUpload()) ||
				(this.PdfUrl == null && !this.Pdf.IsUpload());		
	}
}